import * as React from 'react'

export type FollowersDialogTab = 'followers' | 'following'

export interface FollowersDialogContextModel {
  isOpen: boolean
  openDialog: (slug: string, tab?: FollowersDialogTab) => void
  closeDialog: () => void
  targetSlug: string | null
  initialTab: FollowersDialogTab
}

const FollowersDialogContext = React.createContext<FollowersDialogContextModel>(null!)

export const FollowersDialogProvider = ({ children }: React.PropsWithChildren) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false)
  const [targetSlug, setTargetSlug] = React.useState<string | null>(null)
  const [initialTab, setInitialTab] = React.useState<FollowersDialogTab>('followers')

  const openDialog = (slug: string, tab: FollowersDialogTab = 'followers') => {
    setTargetSlug(slug)
    setInitialTab(tab)
    setIsOpen(true)
  }

  const closeDialog = () => {
    setIsOpen(false)
    setTargetSlug(null)
  }

  return (
    <FollowersDialogContext.Provider
      value={{ isOpen, openDialog, closeDialog, targetSlug, initialTab }}
    >
      {children}
    </FollowersDialogContext.Provider>
  )
}

export const useFollowersDialog = () => {
  const context = React.useContext(FollowersDialogContext)

  if (context === undefined) {
    throw new Error('useFollowersDialog must be used within a FollowersDialogProvider')
  }
  return context
}
